import { render, staticRenderFns } from "./verifyEmailPage.vue?vue&type=template&id=30e4bbf9&scoped=true"
import script from "./verifyEmailPage.vue?vue&type=script&lang=js"
export * from "./verifyEmailPage.vue?vue&type=script&lang=js"
import style0 from "./verifyEmailPage.vue?vue&type=style&index=0&id=30e4bbf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e4bbf9",
  null
  
)

export default component.exports